module.exports = __webpack_public_path__ + "img/07.2ca4e252.png";